// DealerDetailsContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form'
import userService from '@/utils/services/user'
import { useAuth } from '@/hooks/useAuth';
import { UserRoles } from '@/types/user/user_roles';
import useCheckDealerProfile from '@/hooks/useCheckDealerProfile';

export const DealerDetailsContext = createContext(null);

export const DealerDetailsProvider = ({ children }) => {
  const [userId, setUserId] = useState(null);
  const [isFetchingAddress, setFetchingAddress] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const { session } = useAuth()
  const { checkDealerProfile } = useCheckDealerProfile()

  const [userRole] = useState({
    isDealerAdmin: false,
    isDealerAgent: false
  });
  const formController = useForm({
    mode: 'all',
  })

  const setDealerBasicData = (data, setValue) => {
    setValue('phone_number', data?.phone_number)
    setValue('emailId', data?.email)
    setValue('first_name', data?.first_name)
    setValue('last_name', data?.last_name)
    setValue('company', data?.dealer_company)
    setValue('companyId', data?.dealer_company?.id)
    setValue('company_email', data?.dealer_company?.email)
    setValue('company_phone', data?.dealer_company?.phone)
    setValue('manufacturerIdSelected', data?.manufacturer?.id)
    setValue('company_phone', data?.dealer_company?.phone)
    setValue('company_street', data?.dealer_company?.address1)
    setValue('company_city', data?.dealer_company?.city)
    setValue('company_county', data?.dealer_company?.county)
    setValue('company_state_id', data?.dealer_company?.state?.id)
    setValue('company_zip_code', data?.dealer_company?.zip)
    setValue('company_address_apt', data?.dealer_company?.address_apt ?? "")
    setValue('is_verified', data?.dealer_company?.is_verified)
  }

  useEffect(() => {
    const userId = session?.auth?.user?.id

    setUserId(userId)

    const getUserDetails = async () => {
      setLoading(true)
      const response = await userService.getUser(userId)
      checkDealerProfile(response)
      setDealerBasicData(response, formController.setValue)
      setLoading(false)
    }

    if (session?.auth?.user && (session?.auth?.user?.role_id === UserRoles.DEALER)) {
      try {
        getUserDetails()
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error)
      }
    }
  }, [])

  return (
    <DealerDetailsContext.Provider value={{ ...formController, userId, isFetchingAddress, isLoading, userRole }}>
      {children}
    </DealerDetailsContext.Provider>
  );
};

export const useDealerDetails = () => {
  return useContext(DealerDetailsContext);
};
